import React from 'react';
import './css/LoadingScreen.css';

const LoadingScreen = () => {
	return (
        <div className="loading-screen">
        <div className="center-piece">
        	<div className="loading-bar"></div>
        </div>
        </div>
    )
}

export default LoadingScreen;